module.exports = __webpack_public_path__ + "static/media/brand-logo-black.85a58f42.svg";